import { t } from "../../../services/utils";
import React from "react";
import {
  primaryDark,
  primaryDark60,
  primaryDark80,
} from "../../../constants/colors";
import { calculateTextHeight } from "../../../services/utils";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import "./workoutDetailView.css";
import {convertNumberToLocaleString, convertLocaleStringToNumber} from '../../../services/utils';

class WorkoutDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: true,
    };
  }
  toggleDetails = () => {
    this.setState(
      {
        showDetails: !this.state.showDetails,
      },
      () => {
        this.props.handler.recomputeRowHeights();
      }
    );
  };
  render = () => {
    let styles = {
      container: {
        backgroundColor: "white",
        // height: WorkoutDetailView.getHeight(this.props),
        paddingTop: 25,
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
        borderTop: this.props.note ? "1px solid #EAE9EF" : "",
      },
      exerciseContainer: {
        display: "flex",
      },
      workoutDetailsContainer: {
        paddingLeft: 16,
        paddingRight: 16,
        // paddingTop: this.props.note ? 25 : 0,
      },

      workoutDetail: {
        marginBottom: 20,
      },
      main: {
        fontSize: 16,
        color: primaryDark,
        marginRight: 20,
        lineHeight: "20px",
        fontWeight: "500",
      },
      showDetails: {
        color: "#7B62E1",
        fontSize: 16,
        cursor: "pointer",
        marginTop: 22,
      },
      detail: {
        // display: "flex",
        flexWrap: "wrap",
        marginTop: 7,
        // lineHeight: 1.7,
      },

      record: {
        fontSize: 14,
        color: primaryDark80,
        fontWeight: "500",
        // marginRight: 18,
      },

      recordName: {
        fontSize: 14,
        color: primaryDark80,
        marginRight: 3,
        marginLeft: 18,
        fontWeight: "500",
      },
    };
    let text;
    if (this.props.workout.length === 1) {
      text = t("completed_1Exercise");
    } else {
      text = `Completed ${this.props.workout.length} exercises`;
    }
    const { workout } = this.props;
    const { showDetails } = this.state;
    return (
      <div style={styles.container} data-testid="workout-detail">
        {!showDetails ? (
          <div style={styles.exerciseContainer}>
            {workout.map((exercise) => {
              return (
                <div key={exercise.eid} style={styles.main}>
                  {exercise.en}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={styles.workoutDetailsContainer}>
            {workout.map((exercise, index) => {
              let dnt = true;
              if (
                exercise.s !== "0" ||
                exercise.r !== "0" ||
                exercise.w !== "0" ||
                exercise.di !== "0.0" ||
                exercise.du !== "0" ||
                exercise.rm !== 0 ||
                exercise.vol !== 0
              ) {
                dnt = false;
              }
              return (
                <div
                  key={index}
                  style={{
                    ...styles.workoutDetail,
                    ...(index === workout.length - 1 && {
                      marginBottom: 0,
                    }),
                  }}
                >
                  <div style={styles.main}>{exercise.en}</div>
                  <div style={styles.detail} className="workout-detail">
                    {exercise.s !== "0" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("sets")}</span>
                        <span style={styles.record}>{exercise.s}</span>
                      </React.Fragment>
                    )}
                    {exercise.r !== "0" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("reps")}</span>
                        <span style={styles.record}>{exercise.r}</span>
                      </React.Fragment>
                    )}
                    {exercise.di !== "0.0" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("distance")}</span>
                        <span style={styles.record}>{exercise.di}</span>
                      </React.Fragment>
                    )}
                    {exercise.du !== "0" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("duration")}</span>
                        <span style={styles.record}>{exercise.du}</span>
                      </React.Fragment>
                    )}
                    {exercise.w !== "0" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("weight")}</span>
                        <span style={styles.record}>{exercise.w}</span>
                      </React.Fragment>
                    )}
                    {exercise.no && exercise.no !== "null" && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("note")}</span>
                        <span style={styles.record}>{exercise.no}</span>
                      </React.Fragment>
                    )}
                    {exercise.rm !== 0 && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("1Rm")}</span>
                        <span style={styles.record}>{convertNumberToLocaleString(exercise.rm)}</span>
                      </React.Fragment>
                    )}
                    {exercise.vol !== 0 && (
                      <React.Fragment>
                        <span style={styles.recordName}>{t("volume")}</span>
                        <span style={styles.record}>{convertNumberToLocaleString(exercise.vol)}</span>
                      </React.Fragment>
                    )}
                    {dnt && <div style={styles.record}>{t("didNotTrack")}</div>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {/* <div onClick={this.toggleDetails} style={styles.showDetails}>
          {!showDetails ? "Show details" : "Hide Details"}
         </div> */}
      </div>
    );
  };
  static getHeight(props) {
    const { workout, achievements, isModal } = props;
    let storyWidth = isModal ? 620 : STORY_VIEW_WIDTH;
    let extraHeight = 5;
    let hasAchievemements = false;
    if (workout.length > 0) {
      for (let i = 0; i < workout.length; i++) {
        let exercise = workout[i];
        if (exercise.is_pr_rm || exercise.is_pr_vol) {
          hasAchievemements = true;
          break;
        }
      }
    }
    if (hasAchievemements || achievements.length > 0) {
      extraHeight = 20;
    }
    let stringHeight = 0;
    for (let i = 0; i < workout.length; i++) {
      let string = "";
      let exercise = workout[i];
      string += exercise.s !== "0" ? `Sets: ${exercise.s} etc` : "";
      string += exercise.r !== "0" ? `Reps: ${exercise.r} etc` : "";
      string += exercise.di !== "0.0" ? `Distance: ${exercise.di} etc` : "";
      string += exercise.du !== "0" ? `Duration: ${exercise.du} etc` : "";
      string += exercise.w !== "0" ? `Weight: ${exercise.w} etc` : "";
      string +=
        exercise.no && exercise.no !== "null" ? `Note: ${exercise.no}` : "";
      string += exercise.rm !== 0 ? `1RM: ${exercise.rm} etc` : "";
      string += exercise.vol !== 0 ? `Weight: ${exercise.vol} etc` : "";
      string += string === "" ? "Did not track" : "";
      stringHeight += calculateTextHeight(string, storyWidth - 20, {
        fontSize: 14,
      });
      let dnt = true;
      if (
        exercise.s !== "0" ||
        exercise.r !== "0" ||
        exercise.w !== "0" ||
        exercise.di !== "0.0" ||
        exercise.du !== "0" ||
        exercise.rm !== 0 ||
        exercise.vol !== 0
      ) {
        dnt = false;
      }
      if (dnt && exercise.no && exercise.no !== "null") {
        stringHeight += calculateTextHeight(exercise.no, storyWidth - 20, {
          fontSize: 16,
        });
      }
    }
    let paddingTop = 25; // adding 30 2 times because of padding top of container and workout details container
    return (
      workout.length * 19 +
      // exercise name
      workout.length * 20 +
      // Margin bottom
      workout.length * 7 +
      // margin top
      stringHeight +
      // workout's strings height
      paddingTop
      // extraHeight
    );
  }
}

export default WorkoutDetailView;
